import { Route } from 'src/routes/Route'

export const CreateCampaignRoute = Route({ path: '/create' })
export type CreateCampaignRoute = Route<typeof CreateCampaignRoute>
